// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__6vdKv","label":"Loader_label__gowU1","loader":"Loader_loader__ChRMX","bar":"Loader_bar__PHLF4","scale-up4":"Loader_scale-up4__lBCu0"};